<template>
<div class="MLogin m-login">
    <LoginHeader></LoginHeader>
    <div class="m-body">
        <van-tabs v-model="loginType" @click="tabLoginType" animated color="#409EFF" title-active-color="#409EFF" title-inactive-colo="#666666">
            <van-tab title="账号登录">
                <div class="loginContent">
                    <div class="outerBox">
                        <div class="box">
                            <input type="text" class="username" v-model.trim="userInfo.username" auto-complete="off" placeholder="请输入账号/手机号" @blur="checkUsername"
                                   maxlength="11" :class="[rules.username.status?'errorBorder':'']">
                            <i class="icon-phone icon"></i>
                        </div>
                        <div class="tip">
                            <transition name="fade">
                                <span v-if="rules.username.status">{{rules.username.msg}}</span>
                            </transition>
                        </div>
                    </div>
                    <div class="outerBox">
                        <div class="box">
                            <input type="password" class="username" v-model.trim="userInfo.password" auto-complete="off" placeholder="请输入密码" @blur="checkPassword"
                                   maxlength="11" :class="[rules.password.status?'errorBorder':'']">
                            <i class="icon-lock icon"></i>
                        </div>
                        <div class="tip">
                            <transition name="fade">
                                <span v-if="rules.password.status">{{rules.password.msg}}</span>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="loginBtn">
                    <van-button type="info" size="large" @click="doUserLogin">登录</van-button>
                </div>
            </van-tab>
            <van-tab title="手机快捷登录">
                <div class="loginContent">
                    <div class="outerBox">
                        <div class="box">
                            <input type="text" class="username" v-model.trim="item.mobileno" auto-complete="off" placeholder="请输入手机号" @blur="checkMobileno"
                                   maxlength="11" :class="[rules.mobileno.status?'errorBorder':'']">
                            <i class="icon-phone icon"></i>
                        </div>
                        <div class="tip">
                            <transition name="fade">
                                <span v-if="rules.mobileno.status">{{rules.mobileno.msg}}</span>
                            </transition>
                        </div>
                    </div>
                    <div class="outerBox">
                        <div class="box">
                            <input type="text" class="psw" v-model.trim="usercode"  placeholder="请输入图形验证码" maxlength="4" :class="[rules.codeimg.status?'errorBorder':'']">
                            <img @click="createCodeImg" class="code_img" :src="imgCodeUrl" alt="">
                            <i class="icon-lock icon"></i>
                        </div>
                        <div class="tip">
                            <transition name="fade">
                                <span v-if="rules.codeimg.status">{{rules.codeimg.msg}}</span>
                            </transition>
                        </div>
                    </div>
                    <div class="outerBox">
                        <div class="box">
                            <input type="text" class="psw" v-model.trim="item.smscode"  placeholder="请输入验证码" @blur="checkSmscode"
                                   maxlength="4"  :class="[rules.smscode.status?'errorBorder':'']">
                            <van-button type="info" @click="_getSmsCode" :disabled="timer.countdown">{{timer.countdown?timer.num+'s':'获取验证码'}}</van-button>
                            <i class="icon-lock icon"></i>
                        </div>
                        <div class="tip">
                            <transition name="fade">
                                <span v-if="rules.smscode.status">{{rules.smscode.msg}}</span>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="loginBtn">
                    <van-button type="info" size="large" @click="doSmsLogin">登录</van-button>
                </div>
            </van-tab>
        </van-tabs>
    </div>
    <div class="m-footer">
        <router-link :to="{name: 'MRegister'}">注册账号</router-link>
        <router-link :to="{name: 'MResetPwd'}">忘记密码</router-link>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getSmsCode, loginByPassword, loginByMobile, creatImgCode} from 'api/api'
import LoginHeader from 'views/mobile/login/components/loginHeader'
let preRouter = ''
export default {
    name: 'MLogin',
    data() {
        return {
            usercode: '',
            imgCodeUrl: '',
            codeEncryption: '',
            redirect : this.$route.query.redirect?this.$route.query.redirect:'',//来源

            loginType: 0,
            timer: {
                countdown: false,
                num: 90
            },
            item: {
                mobileno: '',
                smscode: ''
            },
            userInfo: {
                username: '',
                password: ''
            },
            rules: {
                mobileno: {status: false, msg: '请输入正确的手机号'},
                smscode: {status: false, msg: '请输入验证码'},
                username: {status: false, msg: '请输入正确的账号/手机号'},
                password: {status: false, msg: '请输入密码'},
                codeimg: {status: false, msg: '请输入图形验证码'},
            },
            preRouterName: ''
        }
    },
    beforeRouteEnter(to, from, next) {
        // alert(JSON.stringify(from))
        // console.log(from)
        preRouter = from
        next()
    },
    mounted() {
        // this.createCodeImg()
    },
    methods: {
        // 获取图形验证码
        createCodeImg() {
            creatImgCode({
                data: {},
                success: data => {
                    // console.log(data.data)
                    this.usercode = ''
                    this.imgCodeUrl = data.result.base64
                    this.codeEncryption = data.result.codeEncryption
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        tabLoginType(e) {
            // console.log(e);
            if (e === 1) {
                this.createCodeImg()
            }
        },
        // 倒计时
        countdown () {
            let _this = this
            let timer = setInterval(() => {
                _this.timer.num--
            }, 1000)
            setTimeout(() => {
                clearInterval(timer)
                _this.timer.countdown = false
                _this.timer.num = 90
            }, 90000)
        },
        checkMobileno() {
            if (!/^1[3-9][0-9]{9}$/.test(this.item.mobileno)) {
                this.rules.mobileno.status = true
            } else {
                this.rules.mobileno.status = false
            }
        },
        checkSmscode() {
            if (!this.item.smscode || this.item.smscode.length !== 4) {
                this.rules.smscode.status = true
            } else {
                this.rules.smscode.status = false
            }
        },
        checkImgcode() {
            if (this.usercode === '') {
                this.rules.codeimg.status = true
            } else {
                this.rules.codeimg.status = false
            }
        },
        checkUsername() {
            if (!this.userInfo.username) {
                this.rules.username.status = true
            } else {
                this.rules.username.status = false
            }
        },
        checkPassword() {
            if (!this.userInfo.password) {
                this.rules.password.status = true
            } else {
                this.rules.password.status = false
            }
        },
        _getSmsCode() {
            this.checkMobileno()
            this.checkImgcode()
            if (!this.rules.mobileno.status && !this.rules.codeimg.status) {
                this.timer.countdown = true
                this.setLoading(true)
                getSmsCode({
                    data: {
                        mobileno: this.item.mobileno,
                        usercode: this.usercode,
                        codeEncryption: this.codeEncryption
                    },
                    success: () => {
                        this.$toast.success('获取验证码成功！')
                        this.countdown()
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.timer.countdown = false
                        this.$toast.fail(data.msg)
                    }
                })
            }
        },
        doUserLogin() {
            this.checkUsername()
            this.checkPassword()
            if (!this.rules.username.status && !this.rules.password.status) {
                this.setLoading(true)
                loginByPassword({
                    data: this.userInfo,
                    success: data => {
                        this._computeUser(data.data.object)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$toast.fail(data.msg)
                    }
                })
            }
        },
        doSmsLogin() {
            this.checkMobileno()
            this.checkSmscode()
            this.checkImgcode()
            if (!this.rules.mobileno.status && !this.rules.smscode.status) {
                this.setLoading(true)
                loginByMobile({
                    data: this.item,
                    success: data => {
                        this._computeUser(data.data.object)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$toast.fail(data.msg)
                    }
                })
            }
        },
        _computeUser(data) {
            let user = {
                innerid: data.innerid,
                loginToken: data.loginToken,
                loginname: data.loginname,
                logourl: data.logourl,
                mobile: data.mobile,
                name: data.name,
                nickname: data.nickname,
                isLogin: true,
                isperfect: data.isperfect,
                zjmemtype: data.zjmemtype ? data.zjmemtype : 0
            }
            sessionStorage.setItem('user', JSON.stringify(user))
            this.setUser(user)
            this.setLoading(false)
            this._setCookie('token', user.loginToken);
            // alert(this.source)
            // alert(preRouter.name)
            // console.log(preRouter.path,preRouter.name,"1111111111111")
            //跳转首页的条件修改，20211208
            // if (preRouter.path && preRouter.path == '/' && preRouter.name !== 'MRegister' && preRouter.name !== 'MResetPwd') {
            //     this.$router.push({name: 'MIndex'})
            // } else {
            //     this.$router.back()
            //     this.setRefresh(true)
            // }
            // console.log(this.redirect)
            // return
            if(this.redirect){
                this.setRefresh(true)
                location.href=this.redirect
                // this.$router.push({path: decodeURIComponent(this.redirect)}) //跳转到原页面
            }
            else if (!preRouter ||
                !preRouter.path ||
                preRouter.path == '/' ||
                (preRouter.name == 'MRegister' || preRouter.name == 'MResetPwd')) {
                this.$router.push({name: 'MIndex'})
            } else {
                this.$router.back()
                this.setRefresh(true)
            }
        },
        _setCookie(key, value, expiredays) {
            let exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie = key + '=' + value
            + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
            + ';path=/'
            + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
        },
        ...mapActions([
            'setUser', 'setLoading', 'setRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        LoginHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~views/mobile/login/login";
@import "~common/scss/variable";
.MLogin {
    .van-tabs__line{
        width: 50% !important;
    }
    .van-tabs__line{
        height: 0.04rem !important;
    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
        border-width: 0 0 0.08rem 0 !important;
    }
    [class*=van-hairline]::after{
        border-bottom: 0.08rem solid $line !important;
    }
}
</style>